import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalStore } from 'src/app/store/global-store';
import { TableFieldDto } from 'src/app/models/tableField.model';
import { environment } from 'src/environment';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';

@Component({
    selector: 'que-choose-auto-fill-field',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ReactiveFormsModule, OverlayModule],
    templateUrl: './choose-auto-fill-field.component.html',
    styleUrls: ['./choose-auto-fill-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseAutoFillFieldComponent {

  fieldId = new FormControl<number | null>(this.data?.id ?? null, [Validators.required]);
  isEditMode = this.data?.isEditMode ?? false;
  usedFieldIds = this.data?.usedFieldIds ?? [];
  tableFields = toSignal(inject(GlobalStore).tableFields$, { initialValue: [] });
  lang = environment.lang;
  isMenuOpen = false;

  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: { id?: number, isEditMode?: boolean, usedFieldIds?: number[] }, private readonly dialogRef: MatDialogRef<ChooseAutoFillFieldComponent>) {
    dialogRef.disableClose = true;
  }

  getSelectedFieldName(): string {
    const selectedField = this.tableFields().find(f => f.id === this.fieldId.value);
    return selectedField ? selectedField.displayName : '';
  }

  isFieldInUse(id: number): boolean {
    return this.usedFieldIds.includes(id);
  }

  get isSelectedFieldInUse(): boolean {
    return this.fieldId.value != null && this.isFieldInUse(this.fieldId.value);
  }

  selectField(id: number) {
    this.fieldId.setValue(id);
    this.isMenuOpen = false;
  }

  cancel() {
    this.dialogRef.close(this.isEditMode ? null : undefined);
  }
  remove() {
    this.dialogRef.close(undefined);
  }
  save() {
    this.dialogRef.close(this.fieldId.value);
  }

}
